import { useEffect, useState } from 'react';
import { ArrowUpCircle } from 'lucide-react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    isVisible && (
      <button
        onClick={scrollToTop}
        className="fixed bottom-20 right-5 z-50 cursor-pointer rounded-full border-none bg-black bg-opacity-50 p-1.5 text-white"
      >
        <ArrowUpCircle size={24} />
      </button>
    )
  );
};

export default ScrollToTopButton;
